export type TTheme = 'light' | 'dark';

const sanitizeThemeValue = (value: string) =>
  value
    .trim()
    .replace(/^['"]+|['"]+$/g, '')
    .toLowerCase();

export const parseTheme = (value: string | null): TTheme => {
  if (!value) {
    return 'light';
  }

  const parsedValue = sanitizeThemeValue(value);
  return parsedValue === 'dark' || parsedValue === 'true' || parsedValue === '1' ? 'dark' : 'light';
};

export const applyTheme = (theme: TTheme) => {
  document.documentElement.dataset.theme = theme;
};

export const getStoredTheme = (): TTheme => {
  try {
    return parseTheme(window.localStorage.getItem('theme'));
  } catch {
    return 'light';
  }
};

export const persistTheme = (theme: TTheme) => {
  try {
    window.localStorage.setItem('theme', theme);
  } catch {
    // Ignore storage exceptions (privacy mode / storage restrictions).
  }
};

export const setTheme = (theme: TTheme) => {
  applyTheme(theme);
  persistTheme(theme);
};
